import { Avatar, AvatarsByType } from '../types/common/Avatar';

export const AVATARS: Avatar[] = [
    // Tank jobs
    { id: 'gladiator', filename: 'gladiator.png', name: 'Gladiator', type: 'tank' },
    { id: 'paladin', filename: 'paladin.png', name: 'Paladin', type: 'tank' },
    { id: 'marauder', filename: 'marauder.png', name: 'Marauder', type: 'tank' },
    { id: 'warrior', filename: 'warrior.png', name: 'Warrior', type: 'tank' },
    { id: 'gunbreaker', filename: 'gunbreaker.png', name: 'Gunbreaker', type: 'tank' },
    { id: 'black_knight', filename: 'black_knight.png', name: 'Dark Knight', type: 'tank' },

    // Healer jobs
    { id: 'conjurer', filename: 'conjurer.png', name: 'Conjurer', type: 'healer' },
    { id: 'white_mage', filename: 'white_mage.png', name: 'White Mage', type: 'healer' },
    { id: 'scholar', filename: 'scholar.png', name: 'Scholar', type: 'healer' },
    { id: 'astromancer', filename: 'astromancer.png', name: 'Astrologian', type: 'healer' },
    { id: 'sage', filename: 'sage.png', name: 'Sage', type: 'healer' },

    // DPS jobs
    { id: 'archer', filename: 'archer.png', name: 'Archer', type: 'dps' },
    { id: 'bard', filename: 'bard.png', name: 'Bard', type: 'dps' },
    { id: 'lancer', filename: 'lancer.png', name: 'Lancer', type: 'dps' },
    { id: 'dragoon', filename: 'dragoon.png', name: 'Dragoon', type: 'dps' },
    { id: 'pugilist', filename: 'pugilist.png', name: 'Pugilist', type: 'dps' },
    { id: 'monk', filename: 'monk.png', name: 'Monk', type: 'dps' },
    { id: 'rogue', filename: 'rogue.png', name: 'Rogue', type: 'dps' },
    { id: 'ninja', filename: 'ninja.png', name: 'Ninja', type: 'dps' },
    { id: 'thaumaturge', filename: 'thaumaturge.png', name: 'Thaumaturge', type: 'dps' },
    { id: 'black_mage', filename: 'black_mage.png', name: 'Black Mage', type: 'dps' },
    { id: 'arcanist', filename: 'arcanist.png', name: 'Arcanist', type: 'dps' },
    { id: 'summoner', filename: 'summoner.png', name: 'Summoner', type: 'dps' },
    { id: 'red_mage', filename: 'red_mage.png', name: 'Red Mage', type: 'dps' },
    { id: 'blue_mage', filename: 'blue_mage.png', name: 'Blue Mage', type: 'dps' },
    { id: 'machinist', filename: 'machinist.png', name: 'Machinist', type: 'dps' },
    { id: 'dancer', filename: 'dancer.png', name: 'Dancer', type: 'dps' },
    { id: 'samurai', filename: 'samurai.png', name: 'Samurai', type: 'dps' },
    { id: 'reaper', filename: 'reaper.png', name: 'Reaper', type: 'dps' },
    { id: 'pictomancer', filename: 'pictomancer.png', name: 'Pictomancer', type: 'dps' },
    { id: 'viper', filename: 'viper.png', name: 'Viper', type: 'dps' },

    // Gatherer jobs
    { id: 'miner', filename: 'miner.png', name: 'Miner', type: 'gatherer' },
    { id: 'botanist', filename: 'botanist.png', name: 'Botanist', type: 'gatherer' },
    { id: 'fisher', filename: 'fisher.png', name: 'Fisher', type: 'gatherer' },

    // Crafter jobs
    { id: 'carpenter', filename: 'carpenter.png', name: 'Carpenter', type: 'crafter' },
    { id: 'blacksmith', filename: 'blacksmith.png', name: 'Blacksmith', type: 'crafter' },
    { id: 'armorer', filename: 'armorer.png', name: 'Armorer', type: 'crafter' },
    { id: 'goldsmith', filename: 'goldsmith.png', name: 'Goldsmith', type: 'crafter' },
    { id: 'leatherworker', filename: 'leatherworker.png', name: 'Leatherworker', type: 'crafter' },
    { id: 'weaver', filename: 'weaver.png', name: 'Weaver', type: 'crafter' },
    { id: 'alchemist', filename: 'alchemist.png', name: 'Alchemist', type: 'crafter' },
    { id: 'culinarian', filename: 'culinarian.png', name: 'Culinarian', type: 'crafter' },

    // Other / miscellaneous
    { id: 'chocobo', filename: 'chocobo.png', name: 'Chocobo', type: 'other' },
    { id: 'carbuncle', filename: 'carbuncle.png', name: 'Carbuncle', type: 'other' },
];

export const getAvatarsByType = (): AvatarsByType => {
    return AVATARS.reduce((acc, avatar) => {
        acc[avatar.type].push(avatar);
        return acc;
    }, {
        tank: [],
        healer: [],
        dps: [],
        crafter: [],
        gatherer: [],
        other: []
    } as AvatarsByType);
};

export const getAvatarById = (id: string): Avatar | undefined => {
    return AVATARS.find(avatar => avatar.id === id);
};

export const getRandomAvatar = (): Avatar => {
    const randomIndex = Math.floor(Math.random() * AVATARS.length);
    return AVATARS[randomIndex];
};